import React from "react";
import { View } from "react-native";
import ThemeProvider from "@voltmoney/theme";
import { ButtonSizeDLS, ButtonTypeDLS, ColorTokens, ImageSizeTokens, SizeTypeTokens, TextAlignTokens, TypographyTypeDLS } from "@voltmoney/schema";
import { Image } from "../../../image/Image";
import { Space } from "../../../space/Space";
import { Button } from "../../../button/Button";
import { Typography } from "../../../typography/Typography";
const CgtcNoPortfolio = ({ pan, phone, toDate, fromDate, editAction, triggerAction }) => {
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    let year1 = fromDate.substring(fromDate.lastIndexOf('-') + 3);
    let year2 = toDate.substring(toDate.lastIndexOf('-') + 3);
    const isSame = year1 === year2;
    year1 = fromDate.substring(fromDate.lastIndexOf('-') + 1);
    return (React.createElement(View, { style: [
            styles.container,
            {
                width: '100%',
                padding: 40,
                backgroundColor: colorMapping[ColorTokens.White]
            }
        ] },
        React.createElement(Image, { size: ImageSizeTokens.SIZE_22, width: 140, height: 140, uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/no_investment_1.png' }),
        React.createElement(Space, { size: SizeTypeTokens.XXXL }),
        React.createElement(View, { style: {
                width: '100%',
                maxWidth: 402
            } }, isSame ?
            React.createElement(Typography, { label: `No capital gains/losses found on mutual funds in financial year ${year1}`, typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center }) :
            React.createElement(Typography, { label: `No capital gains/losses found on mutual funds in financial year ${year1}-${year2}`, typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center })),
        React.createElement(Space, { size: SizeTypeTokens.MD }),
        React.createElement(View, { style: {
                width: '100%',
                maxWidth: 300
            } },
            React.createElement(Typography, { label: `For ${pan} / +91${phone}.\nTry with another mobile or PAN`, typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.center })),
        React.createElement(Space, { size: SizeTypeTokens.XXXL }),
        React.createElement(View, { style: {
                width: '100%',
                maxWidth: 402
            } },
            React.createElement(Button, { label: 'Edit details', typeDLS: ButtonTypeDLS.PRIMARY, sizeDLS: ButtonSizeDLS.LARGE, onPress: async () => {
                    editAction &&
                        await triggerAction(editAction);
                } }))));
};
const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
};
export default CgtcNoPortfolio;
